(function () {
  var KEY = 'socialCounts', FETCH_KEY = 'socialCountsFetched', TTL = 86400000;
  var API_URL = window.SOCIAL_COUNTS_API_URL || 'https://shiny-recipe-aaa4.avramenkodima98.workers.dev/';

  function formatCount(n) {
    if (n >= 1e6) return (n / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
    if (n >= 1e3) return (n / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
    return String(n);
  }

  function apply(arr) {
    if (!Array.isArray(arr)) return;
    document.querySelectorAll('.social-count').forEach(function (el, i) {
      if (arr[i]) el.textContent = arr[i];
    });
  }

  function fromApi(data) {
    if (!data || typeof data.instagram !== 'number' || typeof data.facebook !== 'number' || typeof data.tiktok !== 'number') return null;
    return [formatCount(data.instagram), formatCount(data.facebook), formatCount(data.tiktok)];
  }

  function runUpdate(fallbackCounts) {
    try {
      var last = parseInt(sessionStorage.getItem(FETCH_KEY) || '0', 10);
      if (Date.now() - last < 3600000) return;
      sessionStorage.setItem(FETCH_KEY, String(Date.now()));
    } catch (e) { return; }

    fetch(API_URL)
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (data) {
        var counts = fromApi(data);
        if (counts) {
          var payload = { counts: counts, updatedAt: data.updatedAt || Date.now() };
          try { localStorage.setItem(KEY, JSON.stringify(payload)); } catch (e) {}
          apply(counts);
        } else if (fallbackCounts) apply(fallbackCounts);
      })
      .catch(function () {
        if (fallbackCounts) apply(fallbackCounts);
      });
  }

  var cached;
  try {
    var raw = localStorage.getItem(KEY);
    if (raw) cached = JSON.parse(raw);
  } catch (e) {}
  if (cached && cached.counts) apply(cached.counts);

  if (!cached || !cached.counts || (cached.updatedAt > 0 && (Date.now() - cached.updatedAt) >= TTL)) {
    runUpdate(cached && cached.counts);
  }
})();
